import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(customerSelectorToolbarStyles, {
    searchButton: {
        css: css`
            width: 135px;
            position: inherit;
            left: inherit;
            bottom: inherit;
            text-transform: uppercase;
            border-radius: 22px;
            background-image: linear-gradient(to right, #44a8f7, ${COLORS.link.base});
            border: none;
            color: ${COLORS.white};
            & :hover {
                background: ${COLORS.secondaryBtn};
            }
            &:disabled {
                background: ${COLORS.disabled.base};
            }
            &:disabled:hover {
                background: ${COLORS.disabled.base};
            }
        `,
        typographyProps: {
            css: css`
                font-size: 15px;
                font-weight: 700;
            `,
        },
    },
    wideCreateNewAddressButton: {
        css: css`
            display: none;
        `,
    },
    narrowHidden: {
        css: css`
            display: none;
        `,
    },
    searchTextField: {
        cssOverrides: {
            formField: css`
                flex-basis: 75%;
                margin-right: 5%;
                input {
                    color: ${COLORS.black} !important;
                    font-size: 13px !important;
                    &::placeholder {
                        color: ${COLORS.black} !important;
                    }
                }
            `,
        },
    },
    wrapper: {
        css: css`
            display: flex;
            border-bottom: 1px solid ${getColor("common.border")};
            padding-bottom: 30px;
            justify-content: space-between;
        `,
    },
});
